(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/actions.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/actions.js');

const UPDATE_CUSTOMERINFO_FORM = 'UPDATE_CUSTOMERINFO_FORM';
const UPDATE_ARTICLES = 'UPDATE_ARTICLES';
const ACCEPT_TERMS = 'ACCEPT_TERMS';
const ORDER_SUCCESS = 'ORDER_SUCCESS';
const CLEAR_STATE = 'CLEAR_STATE';

svs.ticket_partner.physicalTickets.actions = {
  UPDATE_CUSTOMERINFO_FORM,
  UPDATE_ARTICLES,
  ACCEPT_TERMS,
  ORDER_SUCCESS,
  CLEAR_STATE
};


 })(window);